<template>
  <mf-tooltip bottom max-width="300px">
    <template v-slot:activator="{ on }">
      <div class="toolbar-custom-btn mx-2 beamerTrigger">
        <mf-icon color="branco" :wght="300" icon="notifications" />
      </div>
    </template>
    <span>Novidades</span>
  </mf-tooltip>
</template>

<script>
export default {
  name: 'Notifications',
}
</script>
